import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Order} from '../../../models/order.model';
import {MobileCheckServiceService} from '../../../services/mobile-check-service.service';
import {OrderService} from '../../../services/order.service';
import {ConfigService} from '../../../services/config.service';
import {MultiTenantService} from '../../../services/multi-tenant.service';
import { DATE_FORMAT } from 'app/constants/date-format';

@Component({
  selector: 'app-order-info',
  templateUrl: './order-info.component.html',
  styleUrls: ['./order-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderInfoComponent implements OnInit {

  @Input() order: Order;

  @Input() orderStatus = '';

  constructor(private orderService: OrderService,
    private mobileCheck: MobileCheckServiceService,
    private configService: ConfigService,
    private multiTenant: MultiTenantService) { }

  ngOnInit(): void {
  }

  get paymentMethod(): string {
    if (!this.order) {
      return '';
    }

    return this.order.creditCard ? 'Credit Card' : 'Terms';
  }

  get status(): string {
    if (this.order?.isRequiredApproval) {
      return this.order.stateDescription;
    }
    return this.orderStatus || this.order.stateDescription;
  }

  get mobileDevice(): boolean {
    return this.mobileCheck.mobileDevice;
  }
  exportToPDF() {
    window.open(`${this.orderService.getApiUrl()}/${this.order.id}/pdf`, '_blank');
  }

  exportToExcel() {
    window.open(`${this.orderService.getApiUrl()}/${this.order.id}/xlsx`, '_blank');
  }

  get showBillingInfo(): boolean {
    return this.configService.showBillingInfo;
  }

  get showNotes(): boolean {
    return this.multiTenant.showOrderNotesOrDeliveryComments;
  }

  get orderNotesLabel(): string {
    return this.multiTenant.orderNotesLabel;
  }

  get showPlanningComments(): boolean {
    return this.multiTenant.showPlanningComments;
  }

  public formatedOrderDate(date): string {
    if(!date){
        return;
    }

    return date.format(DATE_FORMAT.LONG_FORMAT)
  }

  get isOrderCut(): boolean {
    return this.order?.order_cut ? this.order.order_cut : false;
  }
}
